import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CustomerService } from 'src/app/services/customer.service';
import { MessageUtil } from 'src/app/utils/message.util';

@Component({
  selector: 'app-customer-extra-info-form',
  templateUrl: './customer-extra-info-form.component.html',
  styleUrls: ['./customer-extra-info-form.component.scss']
})
export class CustomerExtraInfoFormComponent  implements OnInit {
  customerForm: FormGroup;
  customerId: number;
  isEditMode = false;

  genderOptions = [
    { label: 'Masculino', value: 'M' },
    { label: 'Feminino', value: 'F' }
  ];

  maritalStatusOptions = [
    { label: 'Solteiro', value: 'Solteiro' },
    { label: 'Casado', value: 'Casado' },
    { label: 'Divorciado', value: 'Divorciado' },
    { label: 'Viúvo', value: 'Viúvo' },
    { label: 'Separado', value: 'Separado' }
  ];

  constructor(
    private customerService: CustomerService,
    public dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private spinner: NgxSpinnerService,
    private messageUtil: MessageUtil
  ) {
    this.initializeForm();
  }

  ngOnInit(): void {
    if (this.config.data?.customer) {
      this.customerId = this.config.data.customer.id;
      this.isEditMode = true;
      this.loadCustomerData();
    }
  }

  initializeForm(): void {
    this.customerForm = new FormGroup({
      registration: new FormControl(''),
      gender: new FormControl('M'),
      birthday: new FormControl(null),
      maritalStatus: new FormControl(''),
      spouse: new FormControl(''),
      profession: new FormControl(''),
      phone2: new FormControl(''),
      residentialPhone: new FormControl(''),
      commercialPhone: new FormControl('')
    });
  }

  formatPhoneNumber(phone: string): string {
    if (!phone) return '';
    
    if (phone.match(/^\+\d{2} \(\d{2}\) \d{4,5}-\d{4}$/)) {
      return phone;
    }
    
    const numericOnly = phone.replace(/\D/g, '');
    
    if (numericOnly.length >= 12) {
      return numericOnly.replace(/(\d{2})?(\d{2})?(\d{5})?(\d{4})/, '+$1 ($2) $3-$4');
    } else if (numericOnly.length >= 11) {
      return '+55 ' + numericOnly.replace(/(\d{2})?(\d{5})?(\d{4})/, '($1) $2-$3');
    } else if (numericOnly.length >= 10) {
      return '+55 ' + numericOnly.replace(/(\d{2})?(\d{4})?(\d{4})/, '($1) $2-$3');
    } else {
      return phone;
    }
  }

  loadCustomerData(): void {
    if (this.config.data?.customer) {
      const customer = this.config.data.customer;
      
      this.customerForm.patchValue({
        registration: customer.registration || '',
        gender: customer.gender || 'M',
        birthday: customer.birthday ? new Date(customer.birthday) : null,
        maritalStatus: customer.maritalStatus || '',
        spouse: customer.spouse || '',
        profession: customer.profession || '',
        phone2: this.formatPhoneNumber(customer.phone2) || '',
        commercialPhone: customer.commercialPhone || ''
      });
    } else {
      this.spinner.show();
      this.customerService.getCustomerById(this.customerId).subscribe({
        next: (customer) => {
          this.customerForm.patchValue({
            registration: customer.registration || '',
            gender: customer.gender || 'M',
            birthday: customer.birthday ? new Date(customer.birthday) : null,
            maritalStatus: customer.maritalStatus || '',
            spouse: customer.spouse || '',
            profession: customer.profession || '',
            phone2: this.formatPhoneNumber(customer.phone2) || '',
            residentialPhone: customer.residentialPhone || '',
            commercialPhone: customer.commercialPhone || ''
          });
          this.spinner.hide();
        },
        error: (error) => {
          this.messageUtil.generateMessage('error', 'Erro', 'Falha ao carregar dados do cliente');
          this.spinner.hide();
        }
      });
    }
  }
  

  save(event: Event): void {
    event.preventDefault();
    
    if (this.customerForm.invalid) return;

    this.spinner.show();
    
    if (this.isEditMode) {
      this.customerService.saveCustomerAdditionalInfo(this.customerId, this.customerForm.value).subscribe({
        next: () => {
          this.messageUtil.generateMessage('success', 'Sucesso', 'Dados adicionais atualizados com sucesso!');
          this.dialogRef.close(true);
          this.spinner.hide();
        },
        error: (error) => {
          this.messageUtil.generateMessage('error', 'Erro', 'Falha ao atualizar dados adicionais');
          this.spinner.hide();
        }
      });
    } else {
      this.messageUtil.generateMessage('info', 'Informação', 'Operação não suportada');
      this.spinner.hide();
    }
  }
}